import {
  blue,
  blueGrey,
  cyan,
  deepPurple,
  green,
  grey,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal
} from '@mui/material/colors'

export const stuartColours = [
  'Aqua',
  'Blue',
  'Fuchsia',
  'Green',
  'Lime',
  'Olive',
  'Orange',
  'Purple',
  'Red',
  'Sky Blue',
  'Teal',
  'Tea Rose',
  'Mountain green',
  'Grey green',
  'Grey',
]

const contrastMap = {
  Black: ['cyan', 'lightGreen', 'lime', 'green', 'orange', 'lightBlue', 'grey'],
  White: ['blue', 'pink', 'purple', 'red', 'teal', 'blueGrey', 'deepPurple'],
}

export function contrast(name: string) {
  if (contrastMap.White.includes(name)) {
    return '#FFFFFF'
  }
  return '#000000'
}

export function colourLookup(name: string) {
  let colour
  switch (name) {
    case 'Aqua':
      colour = { main: cyan, contrast: contrast('cyan') }
      break
    case 'Blue':
      colour = { main: blue, contrast: contrast('blue') }
      break
    case 'Fuchsia':
      colour = { main: pink, contrast: contrast('pink') }
      break
    case 'Green':
      colour = { main: lightGreen, contrast: contrast('lightGreen') }
      break
    case 'Lime':
      colour = { main: lime, contrast: contrast('lime') }
      break
    case 'Olive':
      colour = { main: green, contrast: contrast('green') }
      break
    case 'Orange':
      colour = { main: orange, contrast: contrast('orange') }
      break
    case 'Purple':
      colour = { main: purple, contrast: contrast('purple') }
      break
    case 'Red':
      colour = { main: red, contrast: contrast('red') }
      break
    case 'Sky Blue':
      colour = { main: lightBlue, contrast: contrast('lightBlue') }
      break
    case 'Teal':
      colour = { main: teal, contrast: contrast('teal') }
      break
    case 'Tea Rose':
      colour = { main: red, contrast: contrast('red') }
      break
    case 'Mountain green':
      colour = { main: green, contrast: contrast('green') }
      break
    case 'Grey green':
      colour = { main: blueGrey, contrast: contrast('blueGrey') }
      break
    case 'Grey':
      colour = { main: grey, contrast: contrast('grey') }
      break
    default:
      colour = { main: deepPurple, contrast: contrast('deepPurple') }
      break
  }
  return colour
}
